import { Service, isServiceDuration, Duration, VariableDuration } from 'model/Service';

//CORE HELPERS - Safe access to duration properties
export const getSimpleDuration = (service: Service): Duration | undefined => {
    return isServiceDuration(service.duration) ? service.duration.simple : undefined;
};

export const getVariableDuration = (service: Service): Array<VariableDuration> => {
    return isServiceDuration(service.duration) ? service.duration.variable : [];
};

//BOOLEAN HELPERS - Basic verification
export const hasSimpleDuration = (service: Service): boolean => {
    return isServiceDuration(service.duration) && !!service.duration.simple;
};

export const hasVariableDuration = (service: Service): boolean => {
    return isServiceDuration(service.duration) && service.duration.variable.length > 0;
};

//FORMAT HELPER - Reusable duration formatting
export const formatDuration = (hours: number, minutes: number): string => {
    const hoursText = hours === 0 ? '' : hours === 1 ? `${hours} hour` : `${hours} hours`;
    const minutesText = minutes === 0 ? '' : minutes === 1 ? `${minutes} minute` : `${minutes} minutes`;

    if (hours > 0 && minutes > 0) {
        return `${hoursText} ${minutesText}`;
    }
    return hoursText || minutesText || '0 minutes';
};

/**
 * Generates a unique copy name by checking against existing service names
 * @param originalName - The original service name
 * @param existingNames - Array of existing service names to check against
 * @returns A unique name following the pattern: "name (copy)", "name (copy) 2", "name (copy) 3", etc.
 */
export const generateUniqueCopyName = (originalName: string, existingNames: string[]): string => {
    const baseName = originalName.replace(/\s*\(copy(?:\s+\d+)?\)\s*$/i, '').trim();

    let counter = 1;
    let candidateName = `${baseName} (copy)`;

    while (existingNames.includes(candidateName)) {
        counter++;
        candidateName = `${baseName} (copy ${counter})`;
    }

    return candidateName;
};
